import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import {
  IWarehouseProduct,
  WAREHOUSE_PRODUCT_SELECTION_TITLE
} from '../../warehouse-products.interface';
import { WarehouseProductService } from '../../warehouse-products.service';

@Component({
  selector: 'pg-warehouse-product-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class WarehouseProductSelectComponent extends SelectTemplate {
  constructor(private warehouseProductService: WarehouseProductService) {
    super(WAREHOUSE_PRODUCT_SELECTION_TITLE, warehouseProductService);
  }

  ngOnInit() {
    this.table.settings = {
      title: WAREHOUSE_PRODUCT_SELECTION_TITLE,
      columns: [
        { header: 'Nombre del proveedor', field: 'providerName' },
        { header: 'RUC del proveedor', field: 'providerRuc' },
        { header: 'Unidad de medida', field: 'unitMeasureDescription' },
        {
          header: 'Descripción del producto',
          field: 'productOfProviderDescription'
        },
        { header: 'Código del producto', field: 'productOfProviderCode' },
        { header: 'Precio de adquisición', field: 'purchasePrice' },
        { header: 'Cantidad', field: 'quantity' },
        { header: 'Fecha de vencimiento', field: 'expAt' },
        { header: 'Lote', field: 'lot' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.warehouseProductService
      .getData$()
      .subscribe((data: IWarehouseProduct[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
